module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('ShakeMesh', {
    ref: "@play@start@hold-tight",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@hold-tight",
      "link": require('./img/start/hold-tight.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s1 = v
      },
      "exec": function (v) {
        _vm.execStack.s1 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@play@start@start-icon",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@start-icon",
      "link": require('./img/start/start-icon.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s2 = v
      },
      "exec": function (v) {
        _vm.execStack.s2 = v
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@hider",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "position": {
        x: 0,
        y: -32.7,
        z: -1
      },
      "link": require('./img/start/hider-reverse.png')
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@white-ball",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@white-ball",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 0,
      "depthTest": true,
      "transparent": true,
      "link": require('./img/start/white-ball.png')
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@white-ball-text",
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play/countdown'
        })
      },
      "vms": "@play@start@white-ball-text",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 0,
      "depthTest": true,
      "transparent": true,
      "link": require('./img/start/white-ball-text.png')
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('StartAnimation', {
    ref: "@play@canvas@start-canvas",
    attrs: {
      "vms": "@play@canvas@start-canvas"
    },
    on: {
      "exec": function (v) {
        this$1.execStack.startAnimation = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251e2cb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Play/Start.vue
// module id = 581
// module chunks = 0